export default {
    created() {
        this.$eventBus.$on(
            "pages-expand-all",
            function () {
                this.show = true;
            }.bind(this)
        );
        this.$eventBus.$on(
            "pages-minimize-all",
            function () {
                this.show = false;
            }.bind(this)
        );
        this.$eventBus.$on(
            "pages-preview-all",
            function () {
                this.show = true;
                this.preview = true;
            }.bind(this)
        );
        this.$eventBus.$on(
            "pages-edit-all",
            function () {
                this.show = true;
                this.preview = false;
            }.bind(this)
        );
    },
};